var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b2b-input-letters"},[_vm._l((_vm.$_letters),function(letter){return [_c('a',{key:letter,staticClass:"b2b-input-letters__letter",class:{
        'b2b-input-letters__letter--active': letter === _vm.value,
      },domProps:{"textContent":_vm._s(letter)},on:{"click":function($event){$event.stopPropagation();return _vm.$_onClickLetter(letter)}}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }